<template>
  <div class="sub-section">
    <b-field
      class="input-field"
      label="">
      <FilterConfigListEditor
        v-model="inputs"
        :errors="errors"
        :default-time-range="defaultTimeRange"
        :default-time-range-label="defaultTimeRangeLabel" />
    </b-field>
  </div>
</template>

<script>

  import FilterConfigListEditor from '@/components/reports/config/modules/common/FilterConfigListEditor'

  export default {
    name: 'FiltersTab',
    components: {
      FilterConfigListEditor,
    },
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      errors: {
        type: Array,
        default: () => [],
      },
      defaultTimeRange: {
        type: Object,
        default: null,
      },
      defaultTimeRangeLabel: {
        type: String,
        default: 'Use measure default',
      },
    },
    computed: {
      inputs: {
        get () {
          return this.value || []
        },
        set (value) {
          this.$emit('input', value ? value : [])
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
.sub-section {
  padding: 16px;
  overflow: auto;
}
</style>
